module.exports = __webpack_public_path__ + "img/nomad2.a9cc7c22.jpg";